import React from 'react'
import { createSportableApp } from '../index'
import { appConfig } from './config'

export function MatchTracker(initialState, storybook?) {
  return createSportableApp(initialState, appConfig, storybook)
}
